import React from "react";
import {
  DataListItem,
  DataCheckbox,
  EditButton,
  DeleteButton,
  DataError,
} from "components/styled/dataCard/DataCard";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import Radio from "@material-ui/core/Radio";
import ContentLoader from "react-content-loader";
import Tooltip from "@material-ui/core/Tooltip";
import styled from "@material-ui/core/styles/styled";

interface IDataCardRowProps {
  children?: React.ReactNode;
  isLoading: boolean;
  label?: any;
  value?: any;
  tooltip?: string;
  disableTypography?: boolean;
  checked?: boolean;
  deleted?: boolean;
  selected?: boolean;
  error?: string;
  onEdit?: () => void;
  onCheck?: () => void;
  onDelete?: () => void;
  onSelect?: () => void;
  selectable?: boolean;
}

const DataCardRow: React.FC<IDataCardRowProps> = ({
  isLoading,
  label,
  value,
  tooltip = "",
  children,
  disableTypography = true,
  checked = false,
  deleted = false,
  selected = false,
  error,
  onEdit,
  onCheck,
  onDelete,
  onSelect,
  selectable = true,
}) => {
  const hasActions =
    onEdit || onCheck || onDelete || onSelect || deleted || checked;
  const isButton = onSelect ? true : false;

  const valueStyle: React.CSSProperties = selectable
    ? { userSelect: "text" }
    : {};

  return (
    <>
      <Divider variant="fullWidth" component="li" />
      <Tooltip title={tooltip} placement="right">
        <ListItem
          button={isButton as any}
          onClick={onSelect}
          disableGutters
          style={{ height: "55px" }}
        >
          <DataListItem primary={label} />
          <DataListItemBody>
            {isLoading && <LoadingItem />}
            <>
              {!isLoading && (
                <DataListItem
                  disableTypography={disableTypography}
                  secondary={
                    <span style={valueStyle}>{value ?? children}</span>
                  }
                />
              )}

              {!isLoading && (
                <StyledListIcon>
                  {error ? (
                    <DataError message={error} />
                  ) : (
                    <div style={{ width: 24, height: 24 }} />
                  )}

                  {hasActions && (
                    <>
                      {onEdit && <EditButton onClick={onEdit} />}
                      {(onDelete || deleted) && (
                        <DeleteButton onClick={onDelete} value={deleted} />
                      )}
                      {onSelect && (
                        <Radio
                          onClick={onSelect}
                          checked={selected}
                          color="primary"
                        />
                      )}
                      {!error && onCheck && (
                        <DataCheckbox value={checked} onClick={onCheck} />
                      )}
                    </>
                  )}
                </StyledListIcon>
              )}
            </>
          </DataListItemBody>
        </ListItem>
      </Tooltip>
    </>
  );
};

const DataListItemBody = styled("span")({
  minWidth: "auto",
  display: "flex",
  alignItems: "center",
});

const LoadingItem: React.FC = () => {
  return (
    <StyledContentLoader
      height={20}
      width={180}
      speed={1}
      backgroundColor="#f7f8ff"
      foregroundColor="#9e9e9e"
    >
      <rect x="10" y="4" rx="4" ry="4" width="160" height="12" />
    </StyledContentLoader>
  );
};

const StyledContentLoader = styled(ContentLoader)({
  width: 180,
  height: "80%",
});

const StyledListIcon = styled(ListItemIcon)({
  minWidth: 0,
  display: "flex",
  alignItems: "center",
  gap: 8,
});

export default DataCardRow;
